// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clubEventsPage {
  width: 100%;
  min-height: calc(100vh - 88px);
  padding: 0 0 32px;
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #243244);
}

.clubEventsPage__header {
  display: flex;
  width: calc(100% + 48px);
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: -20px 0 18px -24px;
  padding: 10px 72px 10px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.clubEventsPage__headerContext {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 14px;
}

.clubEventsPage__back {
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font: inherit;
  font-size: 12.5px;
  font-weight: 750;
  cursor: pointer;
}

.clubEventsPage__back:hover {
  color: var(--blue-600, #1a6da3);
  text-decoration: underline;
}

.clubEventsPage__headerDivider {
  width: 1px;
  height: 28px;
  flex: 0 0 1px;
  background: var(--border-default, #cbd5e1);
}

.clubEventsPage__headerContext > div {
  min-width: 0;
}

.clubEventsPage__header h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
  line-height: 1.2;
}

.clubEventsPage__header p {
  overflow: hidden;
  margin: 2px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clubEventsPage__stats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.clubEventsPage__stats > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 700;
  white-space: nowrap;
}

.clubEventsPage__stats strong {
  color: var(--text-strong, #0f172a);
  font-size: 11.5px;
  font-weight: 850;
}

.clubEventsPage__stats .isUpcoming {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.clubEventsPage__stats .isUpcoming strong {
  color: var(--blue-700, #155d8c);
}

.clubEventsPage__stats .isCancelled {
  border-color: #fecdd3;
  background: #fff1f2;
}

.clubEventsPage__stats .isCancelled strong {
  color: #be123c;
}

.clubEventsPage__content {
  width: 100%;
  max-width: none;
  margin: 0;
}

.clubEventsPage__list {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.clubEventsPage__list .gridPanelModern {
  margin: 0;
  padding: 0;
}

.clubEventsPage__list .gridPanelTitleRow {
  margin: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.clubEventsPage__list .gridPanelTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 !important;
  flex-wrap: wrap;
}

.clubEventsPage__listTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 2px;
}

.clubEventsPage__listTitle strong {
  color: var(--text-strong, #0f172a);
  font-size: 15.5px;
  font-weight: 750;
  line-height: 1.2;
}

.clubEventsPage__listTitle span {
  display: inline-flex;
  min-width: 26px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}

.clubEventsPage__list .gridModernSearch {
  width: 260px;
  flex: 0 1 260px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
}

.clubEventsPage__list .gridModernSearch > span {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  background: #64748b;
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='11' cy='11' r='6' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='m16 16 4 4' stroke='black' stroke-width='2'/%3E%3C/svg%3E")
    center/16px no-repeat;
}

.clubEventsPage__list .gridModernSearch input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: #142033;
  font-size: 13px;
}

.clubEventsPage__list .gridModernSearch__clear {
  display: inline-flex;
  width: 26px;
  min-width: 26px;
  height: 26px;
  min-height: 26px;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  margin: 0 -5px 0 3px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  box-shadow: none;
  cursor: pointer;
}

.clubEventsPage__list .gridModernSearch__clear:hover,
.clubEventsPage__list .gridModernSearch__clear:focus-visible {
  outline: none;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.clubEventsPage__list .gridModernFiltersAnchor,
.clubEventsPage__list .gridModernColumns {
  position: relative;
  flex: 0 0 auto;
}

.clubEventsPage__list .gridModernFilterButton,
.clubEventsPage__list .gridModernColumns > button {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 0 13px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  box-shadow: none;
  font-size: 13px;
  font-weight: 700;
}

.clubEventsPage__list .gridModernFilterButton > span,
.clubEventsPage__list .gridModernColumns > button > span {
  width: 16px;
  height: 16px;
  background: currentColor;
}

.clubEventsPage__list .gridModernFilterButton > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E")
    center/16px no-repeat;
}

.clubEventsPage__list .gridModernColumns > button > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E")
    center/16px no-repeat;
}

.clubEventsPage__list .gridModernColumns > button b,
.clubEventsPage__list .gridModernFilterButton b {
  min-width: 18px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #eef2f6;
  color: #475569;
  font-size: 10px;
  text-align: center;
}

.clubEventsPage__list .gridModernColumns__menu {
  position: absolute;
  z-index: 1070;
  top: 46px;
  right: 0;
  border: 1px solid #dbe3ec;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);
}

.clubEventsPage__list .gridModernFilterPopover {
  position: fixed;
  z-index: 2147483001;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  margin: 0;
  border: 0;
  border-left: 1px solid var(--border-subtle, #d9e2ec);
  border-radius: 0;
  background: var(--surface-card, #fff);
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}

.clubEventsPage__list .gridModernFilterPopover > header,
.clubEventsPage__list .gridModernColumns__menu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6ebf1;
}

.clubEventsPage__list .gridModernFilterPopover > header {
  min-height: 34px;
  flex: 0 0 auto;
  margin: 18px 18px 0;
  padding: 0 0 12px;
}

.clubEventsPage__list .gridModernFilterPopover > header strong {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 16px;
  font-weight: 800;
}

.clubEventsPage__list .gridModernFilterPopover > header button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.clubEventsPage__list .gridModernFilterPopover > header button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.clubEventsPage__list .gridModernFilterPopover__fields {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 18px;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}

.clubEventsPage__list .gridModernFilterPopover .sit-dp,
.clubEventsPage__list .gridModernFilterPopover .sit-dp__trigger {
  width: 100%;
}

.clubEventsPage__list .gridModernFilterPopover .sit-dp__trigger {
  min-height: 40px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: 8px;
}

.clubEventsPage__list .gridModernFilterChips legend,
.clubEventsPage__list .gridModernFilterPopover .sit-dp__label {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.clubEventsPage__list .gridModernFilterChips {
  margin: 0;
  padding: 0;
  border: 0;
}

.clubEventsPage__list .gridModernFilterChips > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}

.clubEventsPage__list .gridModernFilterChips button {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.clubEventsPage__list .gridModernFilterChips button:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
}

.clubEventsPage__list .gridModernFilterChips button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
  box-shadow: none;
}

.clubEventsPage__list .gridModernFilterPopover > footer {
  display: flex;
  min-height: 69px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding: 14px 18px;
  border-top: 1px solid #e6ebf1;
  border-bottom: 0;
  background: var(--surface-card, #fff);
}

.clubEventsPage__list .gridModernFilterPopover > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clubEventsPage__list .gridModernFilterPopover > footer button {
  min-height: 38px;
  padding: 0 13px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.clubEventsPage__list .gridModernFilterPopover > footer .is-apply {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.clubEventsPage__list .gridModernFilterPopover > footer .is-clear {
  padding: 0;
  border-color: transparent;
  background: transparent;
  color: #1a6da3;
}

.clubEventsPage__list .gridModernFilterPopover > footer .is-apply:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}

.clubEventsPage__list .gridModernFilterPopover .sit-dp__pop {
  position: fixed;
  z-index: 2147483002;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
}

.clubEventsPage__list .gridModernColumns__menu {
  width: 250px;
  padding: 8px;
}

.clubEventsPage__list .gridModernColumns__menu header {
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.clubEventsPage__list .gridModernColumns__menu header button {
  min-height: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-600, #1a6da3);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.clubEventsPage__list .gridModernColumns__menu label {
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  padding: 7px 8px;
  border-radius: 6px;
  color: #334155;
  font-size: 13px;
}

.clubEventsPage__list .gridActiveFilters {
  display: flex;
  min-height: 46px;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  margin: 0;
  padding: 8px 16px 10px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.clubEventsPage__list .gridActiveFilters > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  border: 1px solid #c9e3f2;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
  font-weight: 600;
}

.clubEventsPage__list .gridActiveFilters > span b {
  font-weight: 750;
}

.clubEventsPage__list .gridActiveFilters > span > button {
  display: inline-flex !important;
  width: 18px !important;
  min-width: 18px !important;
  height: 18px !important;
  min-height: 18px !important;
  align-items: center;
  justify-content: center;
  margin: 0 -3px 0 2px !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 50% !important;
  outline: none;
  background: transparent !important;
  color: currentColor !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 1 !important;
  box-shadow: none !important;
  cursor: pointer;
}

.clubEventsPage__list .gridActiveFilters > span > button:hover,
.clubEventsPage__list .gridActiveFilters > span > button:focus-visible {
  background: rgba(21, 93, 140, 0.12) !important;
}

.clubEventsPage__list .gridActiveFilters > button {
  min-height: 28px;
  padding: 0 5px;
  border: 0;
  background: transparent;
  color: var(--blue-600, #1a6da3);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.clubEventsPage__list .gridActiveFilters > button:hover {
  text-decoration: underline;
}

.clubEventsPage__list .gridTableActions {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 8px 12px;
  border: 1px solid #cfe2ef;
  border-radius: 9px;
  background: #f8fbfd;
}

.clubEventsPage__list .gridTableActions__buttons {
  order: -1;
  display: flex;
  gap: 8px;
}

.clubEventsPage__list .gridTableActions__selection {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #60758b;
  font-size: 12px;
  font-weight: 700;
}

.clubEventsPage__list .gridTableActions__selection > strong {
  min-width: 24px;
  height: 24px;
  display: inline-grid;
  place-items: center;
  padding: 0 6px;
  border-radius: 999px;
  color: #155d8c;
  background: #e8f3fa;
  font-size: 11px;
}

.clubEventsPage__list .gridTableActions button.gridTableActions__clear {
  min-height: 0;
  margin-left: 8px;
  padding: 0;
  border: 0;
  border-radius: 0;
  color: #227ebd;
  background: transparent;
  font-size: 12px;
  font-weight: 750;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.clubEventsPage__list .gridTableActions button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.clubEventsPage__list .gridTableActions button.is-danger {
  border-color: #c4313f;
  color: #fff;
  background: #c4313f;
  box-shadow: 0 2px 5px rgba(196, 49, 63, 0.18);
}

.clubEventsPage__list .gridTableActions button.is-danger:hover {
  border-color: #a92734;
  background: #a92734;
}

.clubEventsPage__list > .gridPanel {
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.clubEventsPage__list .table-responsive {
  margin: 0;
}

.clubEventsPage__list table.table {
  margin: 0 !important;
}

.clubEventsPage__list table.table th,
.clubEventsPage__list table.table td {
  height: 56px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-color: var(--border-subtle, #e8edf3);
  font-size: 12.5px;
  vertical-align: middle;
}

.clubEventsPage__list table a {
  color: #243244;
  font-weight: 650;
}

.clubEventsPage__list table input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #227ebd;
}

.clubEventsPage__list table.table th {
  background: var(--surface-subtle, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.clubEventsPage__list table.table tbody tr:hover {
  background: var(--surface-hover, #f8fafc);
}

.clubEventsPage__list .gridModernEmptyRow:hover > td,
.clubEventsPage__list .gridModernEmptyRow > td {
  height: 220px;
  padding: 28px 20px !important;
  background: var(--surface-card, #fff) !important;
  text-align: center;
  vertical-align: middle;
  white-space: normal;
  cursor: default;
}

.clubEventsPage__list .gridModernEmptyRow td > span {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  font-size: 24px;
  line-height: 1;
}

.clubEventsPage__list .gridModernEmptyRow td > strong,
.clubEventsPage__list .gridModernEmptyRow td > small {
  display: block;
  margin-right: auto;
  margin-left: auto;
}

.clubEventsPage__list .gridModernEmptyRow td > strong {
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 750;
  line-height: 1.35;
}

.clubEventsPage__list .gridModernEmptyRow td > small {
  max-width: 420px;
  margin-top: 5px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.45;
}

.clubEventsPage__list .gridModernPagination {
  margin: 0;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.clubEventsStatus {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 3px 9px;
  border: 1px solid var(--border-subtle, #dce4ed);
  border-radius: 999px;
  background: var(--surface-subtle, #f1f5f9);
  color: var(--text-body, #475569);
  font-size: 11px;
  font-weight: 650;
  line-height: 1;
  white-space: nowrap;
}

.clubEventsStatus.isSuccess {
  border-color: var(--success-border, #b7e1cb);
  background: var(--success-surface, #edf9f2);
  color: var(--success-text, #26724a);
}

.clubEventsStatus.isWarning {
  border-color: var(--warning-border, #f2d39b);
  background: var(--warning-surface, #fff8e8);
  color: var(--warning-text, #8a5b12);
}

.clubEventsStatus.isDanger {
  border-color: var(--danger-border, #f3c3ca);
  background: var(--danger-surface, #fff1f3);
  color: var(--danger-text, #b4233c);
}

.clubEventsActionModal__body {
  display: grid;
  gap: 14px;
}

.clubEventsActionModal__banner {
  padding: 10px 12px;
  border: 1px solid var(--warning-border, #f2d39b);
  border-radius: 9px;
  background: var(--warning-surface, #fff8e8);
  color: var(--warning-text, #805513);
  font-size: 12.5px;
}

.clubEventsActionModal__banner.isDanger {
  border-color: var(--danger-border, #f3c3ca);
  background: var(--danger-surface, #fff1f3);
  color: var(--danger-text, #b4233c);
}

.clubEventsActionModal__events {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
}

.clubEventsActionModal__events > div {
  display: grid;
  gap: 2px;
  padding: 10px 12px;
}

.clubEventsActionModal__events > div + div {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.clubEventsActionModal__events strong {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
}

.clubEventsActionModal__events span,
.clubEventsActionModal__field > small {
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}

.clubEventsActionModal__field {
  display: grid;
  gap: 6px;
  margin: 0;
}

.clubEventsActionModal__field > span {
  color: var(--text-strong, #142033);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.clubEventsActionModal__field > span small {
  color: var(--text-muted, #64748b);
  font-weight: 500;
}

.clubEventsActionModal__field textarea {
  min-height: 84px;
  padding: 9px 11px;
  resize: none;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: none;
  color: var(--text-body, #334155);
  font: inherit;
}

.clubEventsActionModal__field textarea:focus {
  border-color: var(--action-primary, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}

.clubEventsActionModal .modal-footer .btn-primary {
  border-color: #227ebd !important;
  background: #227ebd !important;
  color: #fff !important;
}

.clubEventsActionModal .modal-footer .btn-secondary {
  border-color: #cfd8e3 !important;
  background: #fff !important;
  color: #142033 !important;
}

.clubEventsDeleteModal .modal-footer .btn-primary {
  border-color: #c23648 !important;
  background: #c23648 !important;
}

@media (max-width: 900px) {
  .clubEventsPage__header {
    min-height: 106px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .clubEventsPage__stats {
    justify-content: flex-start;
  }
}

@media (max-width: 1217px) {
  .clubEventsPage__header {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 720px) {
  .clubEventsPage {
    padding-bottom: 20px;
  }

  .clubEventsPage__header {
    width: calc(100% + 24px);
    margin-right: -12px;
    padding-right: 16px;
    padding-left: 16px;
  }

  .clubEventsPage__headerContext {
    gap: 9px;
  }

  .clubEventsPage__headerDivider {
    height: 24px;
  }

  .clubEventsPage__list .gridModernSearch {
    width: 100%;
    flex-basis: 100%;
  }
}

@media (max-width: 600px) {
  .clubEventsPage__list .gridModernFilterPopover {
    left: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Clubs/Clubs/ClubEvents/ClubEvents.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+CAA+C;EAC/C,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB;yBACuB;AACzB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE;yBACuB;AACzB;;AAEA;EACE;yBACuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,oDAAoD;EACpD,gBAAgB;EAChB,qCAAqC;EACrC,wFAAwF;AAC1F;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,gDAAgD;EAChD,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,2CAA2C;EAC3C,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".clubEventsPage {\n  width: 100%;\n  min-height: calc(100vh - 88px);\n  padding: 0 0 32px;\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #243244);\n}\n\n.clubEventsPage__header {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 82px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: -20px 0 18px -24px;\n  padding: 10px 72px 10px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.clubEventsPage__headerContext {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 14px;\n}\n\n.clubEventsPage__back {\n  flex: 0 0 auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.clubEventsPage__back:hover {\n  color: var(--blue-600, #1a6da3);\n  text-decoration: underline;\n}\n\n.clubEventsPage__headerDivider {\n  width: 1px;\n  height: 28px;\n  flex: 0 0 1px;\n  background: var(--border-default, #cbd5e1);\n}\n\n.clubEventsPage__headerContext > div {\n  min-width: 0;\n}\n\n.clubEventsPage__header h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.clubEventsPage__header p {\n  overflow: hidden;\n  margin: 2px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.clubEventsPage__stats {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.clubEventsPage__stats > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 9px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.clubEventsPage__stats strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 11.5px;\n  font-weight: 850;\n}\n\n.clubEventsPage__stats .isUpcoming {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n\n.clubEventsPage__stats .isUpcoming strong {\n  color: var(--blue-700, #155d8c);\n}\n\n.clubEventsPage__stats .isCancelled {\n  border-color: #fecdd3;\n  background: #fff1f2;\n}\n\n.clubEventsPage__stats .isCancelled strong {\n  color: #be123c;\n}\n\n.clubEventsPage__content {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.clubEventsPage__list {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.clubEventsPage__list .gridPanelModern {\n  margin: 0;\n  padding: 0;\n}\n\n.clubEventsPage__list .gridPanelTitleRow {\n  margin: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubEventsPage__list .gridPanelTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 !important;\n  flex-wrap: wrap;\n}\n\n.clubEventsPage__listTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 2px;\n}\n\n.clubEventsPage__listTitle strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 15.5px;\n  font-weight: 750;\n  line-height: 1.2;\n}\n\n.clubEventsPage__listTitle span {\n  display: inline-flex;\n  min-width: 26px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.clubEventsPage__list .gridModernSearch {\n  width: 260px;\n  flex: 0 1 260px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.clubEventsPage__list .gridModernSearch > span {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  background: #64748b;\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='11' cy='11' r='6' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='m16 16 4 4' stroke='black' stroke-width='2'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n\n.clubEventsPage__list .gridModernSearch input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #142033;\n  font-size: 13px;\n}\n\n.clubEventsPage__list .gridModernSearch__clear {\n  display: inline-flex;\n  width: 26px;\n  min-width: 26px;\n  height: 26px;\n  min-height: 26px;\n  flex: 0 0 26px;\n  align-items: center;\n  justify-content: center;\n  margin: 0 -5px 0 3px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1;\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridModernSearch__clear:hover,\n.clubEventsPage__list .gridModernSearch__clear:focus-visible {\n  outline: none;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.clubEventsPage__list .gridModernFiltersAnchor,\n.clubEventsPage__list .gridModernColumns {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.clubEventsPage__list .gridModernFilterButton,\n.clubEventsPage__list .gridModernColumns > button {\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  padding: 0 13px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  box-shadow: none;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.clubEventsPage__list .gridModernFilterButton > span,\n.clubEventsPage__list .gridModernColumns > button > span {\n  width: 16px;\n  height: 16px;\n  background: currentColor;\n}\n\n.clubEventsPage__list .gridModernFilterButton > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n\n.clubEventsPage__list .gridModernColumns > button > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n\n.clubEventsPage__list .gridModernColumns > button b,\n.clubEventsPage__list .gridModernFilterButton b {\n  min-width: 18px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #475569;\n  font-size: 10px;\n  text-align: center;\n}\n\n.clubEventsPage__list .gridModernColumns__menu {\n  position: absolute;\n  z-index: 1070;\n  top: 46px;\n  right: 0;\n  border: 1px solid #dbe3ec;\n  border-radius: 11px;\n  background: #fff;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.16);\n}\n\n.clubEventsPage__list .gridModernFilterPopover {\n  position: fixed;\n  z-index: 2147483001;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  margin: 0;\n  border: 0;\n  border-left: 1px solid var(--border-subtle, #d9e2ec);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.clubEventsPage__list .gridModernFilterPopover > header,\n.clubEventsPage__list .gridModernColumns__menu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e6ebf1;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > header {\n  min-height: 34px;\n  flex: 0 0 auto;\n  margin: 18px 18px 0;\n  padding: 0 0 12px;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > header strong {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > header button {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > header button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.clubEventsPage__list .gridModernFilterPopover__fields {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 18px;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.clubEventsPage__list .gridModernFilterPopover .sit-dp,\n.clubEventsPage__list .gridModernFilterPopover .sit-dp__trigger {\n  width: 100%;\n}\n\n.clubEventsPage__list .gridModernFilterPopover .sit-dp__trigger {\n  min-height: 40px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 8px;\n}\n\n.clubEventsPage__list .gridModernFilterChips legend,\n.clubEventsPage__list .gridModernFilterPopover .sit-dp__label {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.clubEventsPage__list .gridModernFilterChips {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.clubEventsPage__list .gridModernFilterChips > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 8px;\n}\n\n.clubEventsPage__list .gridModernFilterChips button {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridModernFilterChips button:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n\n.clubEventsPage__list .gridModernFilterChips button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  box-shadow: none;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer {\n  display: flex;\n  min-height: 69px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding: 14px 18px;\n  border-top: 1px solid #e6ebf1;\n  border-bottom: 0;\n  background: var(--surface-card, #fff);\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer button {\n  min-height: 38px;\n  padding: 0 13px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer .is-apply {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer .is-clear {\n  padding: 0;\n  border-color: transparent;\n  background: transparent;\n  color: #1a6da3;\n}\n\n.clubEventsPage__list .gridModernFilterPopover > footer .is-apply:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n\n.clubEventsPage__list .gridModernFilterPopover .sit-dp__pop {\n  position: fixed;\n  z-index: 2147483002;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n}\n\n.clubEventsPage__list .gridModernColumns__menu {\n  width: 250px;\n  padding: 8px;\n}\n\n.clubEventsPage__list .gridModernColumns__menu header {\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.clubEventsPage__list .gridModernColumns__menu header button {\n  min-height: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-600, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridModernColumns__menu label {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 0;\n  padding: 7px 8px;\n  border-radius: 6px;\n  color: #334155;\n  font-size: 13px;\n}\n\n.clubEventsPage__list .gridActiveFilters {\n  display: flex;\n  min-height: 46px;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 8px 16px 10px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubEventsPage__list .gridActiveFilters > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 10px;\n  border: 1px solid #c9e3f2;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.clubEventsPage__list .gridActiveFilters > span b {\n  font-weight: 750;\n}\n\n.clubEventsPage__list .gridActiveFilters > span > button {\n  display: inline-flex !important;\n  width: 18px !important;\n  min-width: 18px !important;\n  height: 18px !important;\n  min-height: 18px !important;\n  align-items: center;\n  justify-content: center;\n  margin: 0 -3px 0 2px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 50% !important;\n  outline: none;\n  background: transparent !important;\n  color: currentColor !important;\n  font-size: 16px !important;\n  font-weight: 400 !important;\n  line-height: 1 !important;\n  box-shadow: none !important;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridActiveFilters > span > button:hover,\n.clubEventsPage__list .gridActiveFilters > span > button:focus-visible {\n  background: rgba(21, 93, 140, 0.12) !important;\n}\n\n.clubEventsPage__list .gridActiveFilters > button {\n  min-height: 28px;\n  padding: 0 5px;\n  border: 0;\n  background: transparent;\n  color: var(--blue-600, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridActiveFilters > button:hover {\n  text-decoration: underline;\n}\n\n.clubEventsPage__list .gridTableActions {\n  min-height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n  padding: 8px 12px;\n  border: 1px solid #cfe2ef;\n  border-radius: 9px;\n  background: #f8fbfd;\n}\n\n.clubEventsPage__list .gridTableActions__buttons {\n  order: -1;\n  display: flex;\n  gap: 8px;\n}\n\n.clubEventsPage__list .gridTableActions__selection {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #60758b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.clubEventsPage__list .gridTableActions__selection > strong {\n  min-width: 24px;\n  height: 24px;\n  display: inline-grid;\n  place-items: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  color: #155d8c;\n  background: #e8f3fa;\n  font-size: 11px;\n}\n\n.clubEventsPage__list .gridTableActions button.gridTableActions__clear {\n  min-height: 0;\n  margin-left: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  color: #227ebd;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 750;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\n.clubEventsPage__list .gridTableActions button {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.clubEventsPage__list .gridTableActions button.is-danger {\n  border-color: #c4313f;\n  color: #fff;\n  background: #c4313f;\n  box-shadow: 0 2px 5px rgba(196, 49, 63, 0.18);\n}\n\n.clubEventsPage__list .gridTableActions button.is-danger:hover {\n  border-color: #a92734;\n  background: #a92734;\n}\n\n.clubEventsPage__list > .gridPanel {\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubEventsPage__list .table-responsive {\n  margin: 0;\n}\n\n.clubEventsPage__list table.table {\n  margin: 0 !important;\n}\n\n.clubEventsPage__list table.table th,\n.clubEventsPage__list table.table td {\n  height: 56px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-color: var(--border-subtle, #e8edf3);\n  font-size: 12.5px;\n  vertical-align: middle;\n}\n\n.clubEventsPage__list table a {\n  color: #243244;\n  font-weight: 650;\n}\n\n.clubEventsPage__list table input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: #227ebd;\n}\n\n.clubEventsPage__list table.table th {\n  background: var(--surface-subtle, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.clubEventsPage__list table.table tbody tr:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n\n.clubEventsPage__list .gridModernEmptyRow:hover > td,\n.clubEventsPage__list .gridModernEmptyRow > td {\n  height: 220px;\n  padding: 28px 20px !important;\n  background: var(--surface-card, #fff) !important;\n  text-align: center;\n  vertical-align: middle;\n  white-space: normal;\n  cursor: default;\n}\n\n.clubEventsPage__list .gridModernEmptyRow td > span {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 10px;\n  border-radius: 50%;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  font-size: 24px;\n  line-height: 1;\n}\n\n.clubEventsPage__list .gridModernEmptyRow td > strong,\n.clubEventsPage__list .gridModernEmptyRow td > small {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.clubEventsPage__list .gridModernEmptyRow td > strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 750;\n  line-height: 1.35;\n}\n\n.clubEventsPage__list .gridModernEmptyRow td > small {\n  max-width: 420px;\n  margin-top: 5px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 400;\n  line-height: 1.45;\n}\n\n.clubEventsPage__list .gridModernPagination {\n  margin: 0;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubEventsStatus {\n  display: inline-flex;\n  min-height: 24px;\n  align-items: center;\n  padding: 3px 9px;\n  border: 1px solid var(--border-subtle, #dce4ed);\n  border-radius: 999px;\n  background: var(--surface-subtle, #f1f5f9);\n  color: var(--text-body, #475569);\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.clubEventsStatus.isSuccess {\n  border-color: var(--success-border, #b7e1cb);\n  background: var(--success-surface, #edf9f2);\n  color: var(--success-text, #26724a);\n}\n\n.clubEventsStatus.isWarning {\n  border-color: var(--warning-border, #f2d39b);\n  background: var(--warning-surface, #fff8e8);\n  color: var(--warning-text, #8a5b12);\n}\n\n.clubEventsStatus.isDanger {\n  border-color: var(--danger-border, #f3c3ca);\n  background: var(--danger-surface, #fff1f3);\n  color: var(--danger-text, #b4233c);\n}\n\n.clubEventsActionModal__body {\n  display: grid;\n  gap: 14px;\n}\n\n.clubEventsActionModal__banner {\n  padding: 10px 12px;\n  border: 1px solid var(--warning-border, #f2d39b);\n  border-radius: 9px;\n  background: var(--warning-surface, #fff8e8);\n  color: var(--warning-text, #805513);\n  font-size: 12.5px;\n}\n\n.clubEventsActionModal__banner.isDanger {\n  border-color: var(--danger-border, #f3c3ca);\n  background: var(--danger-surface, #fff1f3);\n  color: var(--danger-text, #b4233c);\n}\n\n.clubEventsActionModal__events {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n}\n\n.clubEventsActionModal__events > div {\n  display: grid;\n  gap: 2px;\n  padding: 10px 12px;\n}\n\n.clubEventsActionModal__events > div + div {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubEventsActionModal__events strong {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n}\n\n.clubEventsActionModal__events span,\n.clubEventsActionModal__field > small {\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n\n.clubEventsActionModal__field {\n  display: grid;\n  gap: 6px;\n  margin: 0;\n}\n\n.clubEventsActionModal__field > span {\n  color: var(--text-strong, #142033);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.clubEventsActionModal__field > span small {\n  color: var(--text-muted, #64748b);\n  font-weight: 500;\n}\n\n.clubEventsActionModal__field textarea {\n  min-height: 84px;\n  padding: 9px 11px;\n  resize: none;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: none;\n  color: var(--text-body, #334155);\n  font: inherit;\n}\n\n.clubEventsActionModal__field textarea:focus {\n  border-color: var(--action-primary, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n\n.clubEventsActionModal .modal-footer .btn-primary {\n  border-color: #227ebd !important;\n  background: #227ebd !important;\n  color: #fff !important;\n}\n\n.clubEventsActionModal .modal-footer .btn-secondary {\n  border-color: #cfd8e3 !important;\n  background: #fff !important;\n  color: #142033 !important;\n}\n\n.clubEventsDeleteModal .modal-footer .btn-primary {\n  border-color: #c23648 !important;\n  background: #c23648 !important;\n}\n\n@media (max-width: 900px) {\n  .clubEventsPage__header {\n    min-height: 106px;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }\n\n  .clubEventsPage__stats {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 1217px) {\n  .clubEventsPage__header {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 720px) {\n  .clubEventsPage {\n    padding-bottom: 20px;\n  }\n\n  .clubEventsPage__header {\n    width: calc(100% + 24px);\n    margin-right: -12px;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .clubEventsPage__headerContext {\n    gap: 9px;\n  }\n\n  .clubEventsPage__headerDivider {\n    height: 24px;\n  }\n\n  .clubEventsPage__list .gridModernSearch {\n    width: 100%;\n    flex-basis: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .clubEventsPage__list .gridModernFilterPopover {\n    left: 0;\n    width: 100vw;\n    max-width: none;\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
